import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.tpbwp-carousel').forEach((carouselEl) => {
        const swiperContainer = carouselEl.querySelector('.swiper');
        const wrapper = swiperContainer?.querySelector('.swiper-wrapper');
        if (!swiperContainer || !wrapper) return;

        // Ensure each child has swiper-slide
        wrapper.querySelectorAll(':scope > *').forEach((child) => {
            if (!child.classList.contains('swiper-slide')) {
                child.classList.add('swiper-slide');
            }
        });

        const settings = JSON.parse(carouselEl.dataset.settings || '{}');

        // 🔑 Normalize breakpoints: add slidesPerGroup = slidesPerView
        const normalizedBreakpoints = {};
        if (settings.breakpoints) {
            Object.entries(settings.breakpoints).forEach(([bp, conf]) => {
                normalizedBreakpoints[bp] = {
                    slidesPerView: conf.slidesPerView || 1,
                    slidesPerGroup: conf.slidesPerView || 1, // ✅ sync navigation step
                };
            });
        }

        const config = {
            modules: [Navigation, Pagination, Autoplay],
            slidesPerView: 1, // ✅ fallback
            spaceBetween: settings.spaceBetween || 0,
            speed: settings.speed || 300,
            centeredSlides: settings.centeredSlides || false,
            autoHeight: settings.autoHeight || false,
            loop: true,
            breakpoints: normalizedBreakpoints,
        };

        if (settings.pagination) {
            config.pagination = {
                el: carouselEl.querySelector('.swiper-pagination'),
                clickable: true,
            };
        }

        if (settings.navigation) {
            config.navigation = {
                nextEl: carouselEl.querySelector('.swiper-button-next'),
                prevEl: carouselEl.querySelector('.swiper-button-prev'),
            };
        }

        if (settings.autoplay) {
            config.autoplay = settings.autoplay;
        }

        new Swiper(swiperContainer, config);
    });
});
